import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";

const BasicTable = ({ onViewClick }) => {
    const rows = [
        {
            id: 1,
            name: "John Doe",
            phoneno: "+145145625",
            history: [
                {
                    date: "2024-02-01",
                    time: "10:00 AM",
                    status: "Completed",
                    notes: "Discussed job requirements and next steps.",
                    recording: "https://www.example.com/recording1.mp3",
                },
            ],
        },
        {
            id: 2,
            name: "Jane Smith",
            phoneno: "+745752146530",
            history: [
                {
                    date: "2024-01-25",
                    time: "2:15 PM",
                    status: "In Progress",
                    notes: "Candidate showed interest in the position. Follow-up next week.",
                    recording: "https://www.example.com/recording2.mp3",
                },
            ],
        },
    ];

    return (
        <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
            <Table>
                <TableHead>
                    <TableRow sx={{ bgcolor: "grey.200" }}>
                        <TableCell>ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Contact Number</TableCell>
                        <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.phoneno}</TableCell>
                            <TableCell>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    sx={{ textTransform: "none" }}
                                    onClick={() => onViewClick(row)}
                                >
                                    View
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BasicTable;
